import { useEffect, useState } from "react";

export default function RandomQuote() {
  const [quote, setQuote] = useState(null);

  useEffect(() => {
    const fetchQuote = async () => {
      try {
        const res = await fetch("/data/inspirational_quotes.json");
        const quotes = await res.json();
        const random = quotes[Math.floor(Math.random() * quotes.length)];
        setQuote(random);
      } catch (err) {
        console.error("Failed to load quotes:", err);
      }
    };

    fetchQuote();
  }, []);

  if (!quote) return null;

  return (
    <div
      style={{
        marginTop: "2rem",
        fontStyle: "italic",
        textAlign: "center",
        color: "white",
      }}
    >
      <p>"{quote.quote}"</p>
      <p style={{ fontWeight: "bold", marginTop: "0.5rem" }}>
        — {quote.author}
      </p>
    </div>
  );
}
